module.exports = __webpack_public_path__ + "img/bg-trailer.887e5556.jpg";